import { Grid, Group, Iframe, Layout, Page, Tab } from "@/comn/components";
import {
    useAuth,
    useFetch,
    useForm,
    useGrid,
    useModal,
    usePage,
    useResource,
    useStore,
    useTab,
    useToast,
} from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import {
    APIS,
    SF_APRV_DOC_INFO,
    SF_APRV_HIST_INFO,
    SF_APRV_PRCS_INFO,
    SF_APRV_RQST_INFO,
    SG_APRV_HIST_LIST,
    URLS,
} from "./services/OsciAprvService";
import { OSCI0108006Q } from "./OSCI0108006Q";

/*
 * Popup for Approval Request
 * !== 결재 처리 화면 ==!
 */
export const OSCI0108005S = (): JSX.Element => {
    useResource({
        defaultSchema: [{ area: "cstmOfcrCd" }],
    });

    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { aprvId, usrDmnId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!
    const searchParams = new URLSearchParams(window.location.search);
    const flag = searchParams.get("flag"); // Whether to move the detailed screen from the Approval list (waiting:W/progress:P/completed:C/request:R) !== 결재 목록에서 상세 화면 이동 여부 (대기:W/진행중:P/완료:C/요청:R) ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const [iframeSrc, setIframeSrc] = useState("");
    const [aprvChgAuthYn, setAprvChgAuthYn] = useState("N"); // Authorization to change approver Y/N !== 전자결재 결재자 변경 권한 여부 ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Approval Request Information Form !== 결재 요청 정보 폼 form ==!
        aprvRqstInfo: useForm({
            defaultSchema: SF_APRV_RQST_INFO,
            defaultValues: {},
        }),

        // Approval Document Information Form !== 결재 문서 폼 form ==!
        aprvDocInfo: useForm({
            defaultSchema: SF_APRV_DOC_INFO,
            defaultValues: {},
        }),
        // Approval History Information Form !== 결재 이력 폼 form ==!
        aprvHistInfo: useForm({
            defaultSchema: SF_APRV_HIST_INFO,
            defaultValues: { aprvId: aprvId },
        }),

        // Approval Processing Information Form !== 결재 처리 폼 form ==!
        aprvPrcsInfo: useForm({
            defaultSchema: SF_APRV_PRCS_INFO,
            defaultValues: {},
        }),
    };

    // Tab of Approval Document, History,Processing  !== 결재문서/결재이력/결재처리 탭 ==!
    const tab = useTab({
        defaultSchema: {
            id: "tab",
            schema: [{ label: "L_APRV_DOC" }, { label: "L_APRV_HIST" }, { label: "L_APRV_PROC" }],
        },
    });

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Request Approval Status List !== 결재 이력 목록 ==!
        aprvHistList: useGrid({
            defaultSchema: SG_APRV_HIST_LIST,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Check Approval Path Information !== 결재 요청 정보 조회 ==!
        getAprvRqstInfo: useFetch({
            api: () => APIS.getAprvRqstInfo({ aprvId: aprvId, usrDmnId: usrDmnId }),
            enabled: !!aprvId,
            onSuccess: (data) => {
                const getDataInfo = data.aprvRqstInfo.content;
                console.log("getDataInfo", getDataInfo);
                form.aprvRqstInfo.setValues(getDataInfo);

                let frontDmn;
                const getBsopClsfCd = form.aprvRqstInfo.getValue("bsopClsfCd");
                frontDmn = process.env.REACT_APP_API_FRONT_PTL_COMN;

                setIframeSrc(
                    `${frontDmn}${form.aprvRqstInfo.getValue("docMakeUrlAddr")}${form.aprvRqstInfo.getValue(
                        "aprvReffId",
                    )}?menuId=elecAprv&aprvId=${form.aprvRqstInfo.getValue("aprvId")}`,
                );

                // 화물의 경우 무조건 RETURN이 나와야 함.
                // if (
                //     getDataInfo.bsopClsfCd === "CGM" ||
                //     getDataInfo.bsopClsfCd === "OLM" ||
                //     getDataInfo.bsopClsfCd === "EFM" ||
                //     getDataInfo.bsopClsfCd === "ECT" ||
                //     getDataInfo.bsopClsfCd === "SCT"
                // ) {
                // } else {
                //     if (getDataInfo.prevStageRtrnUseYn === "N" || getDataInfo.lgnUsrAprvPrcssOrd == 2) {
                //         form.aprvPrcsInfo.setSchema("lastAprvYn", {
                //             options: [
                //                 { label: "Approved", value: "Y" },
                //                 { label: "Rejected", value: "N" },
                //             ],
                //         });
                //     }
                // }

                if (getDataInfo.rjctStatUseYn === "N") {
                    form.aprvPrcsInfo.setSchema("lastAprvYn", {
                        options: [
                            { label: "Approved", value: "Y" },
                            { label: "Returned", value: "P" },
                        ],
                    });
                }
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),

        //  Check Approval History List !== 결재 이력 목록 조회  ==!
        getAprvHistList: useFetch({
            api: (page = grid.aprvHistList.page) =>
                APIS.getAprvHistList(form.aprvHistInfo.getValues(), page, grid.aprvHistList.size),
            enabled: !!aprvId,
            key: [grid.aprvHistList.page, grid.aprvHistList.size],
            onSuccess: () => {
                // setStore(pgeUid, {
                //     form: form.aprvHistInfo.getValues(),
                //     page: grid.aprvHistList.page,
                //     size: grid.aprvHistList.size,
                // });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        // Check Approval Path Information !== 결재 이력 정보 조회 ==!
        getAprvHistInfo: useFetch({
            api: () => APIS.getAprvHistInfo(form.aprvHistInfo.getValues()),
            enabled:
                !!comnUtils.isEmpty(form.aprvHistInfo.errors) &&
                !comnUtils.isEmpty(form.aprvHistInfo.getValue("usrDmnId")),
            onSuccess: (data) => {
                console.log("getAprvHistInfo", data);
                const aprvInfo = data.aprvHistInfo.content;
                form.aprvHistInfo.setValues(aprvInfo);
                // form.aprvHistInfo.setValue("cstmOfcrCd", getDataInfo.usrDmnId);
                form.aprvHistInfo.setValue("orgUsrId", aprvInfo.usrDmnId);
                form.aprvHistInfo.setValue("orgUsrNm", aprvInfo.usrNm);

                // 기존에 승인하지 않은 경우
                if (aprvInfo.aprvPrcssDoneYn === "N" && aprvInfo.aprvPrcssSeq !== "1") {
                    form.aprvHistInfo.setValue("aprvPrcssDtm", "");
                    form.aprvHistInfo.setSchema("orgUsrNm", {
                        // Can only modify Approval Wait state in the Auth to Change Approver on the [Waiting for Approval/Approval in Progress] Tab !== [결재대기/결재진행중] 탭에서 결재대기 상태의 결재자 변경 권한만 수정 가능 ==!
                        edit:
                            aprvChgAuthYn == "N" &&
                            !["W", "P"].includes(flag || "") &&
                            form.aprvHistInfo.getValue("aprvPrcssMetdCd") !== "M03"
                                ? false
                                : true,
                    });
                } else {
                    // form.aprvHistInfo.setSchema("cstmOfcrCd", { disabled: true });
                    form.aprvHistInfo.setSchema("orgUsrNm", { edit: false });
                }
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        // Save Approval Path Information !== 결재 승인 처리 저장 ==!
        saveAprvPrcsInfo: useFetch({
            api: (data: any) => APIS.saveAprvPrcsInfo(data),
            enabled: false,
            onSuccess: (data) => {
                let msg = "msg.osc.00069"; // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
                if (!comnUtils.isEmpty(data.afPrcssSucsYn.content)) {
                    if (data.afPrcssSucsYn.content === "N") {
                        msg = "msg.osc.00127"; // Approval post-processing request exception !== 승인 후 처리 예외 발생 ==!
                    }
                }

                modal.openModal({
                    content: msg,
                    onConfirm: () => {
                        navigate(URLS.osci0108004q);
                    },
                    close: false,
                }); // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
            },
            onError: (error) => {
                console.log("error", error);
                toast.showToast({ type: "error", content: "msg.osc.00045" }); // Failed to save. !== 저장이 실패하였습니다. ==!

                let errorMessage = error.message;
                if (error.response?.data?.errorMessage) {
                    errorMessage = error.response.data.errorMessage;
                }
                modal.openModal({ content: errorMessage });
            },
        }),
        // Save Approval Path Information !== 결재 요청 취소 저장 ==!
        saveAprvCnclInfo: useFetch({
            api: (data: any) => APIS.saveAprvCnclInfo(data),
            enabled: false,
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00069", // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
                });
                navigate(URLS.osci0108004q);
            },
            onError: (error) => {
                console.log("error", error);
                toast.showToast({ type: "error", content: "msg.osc.00045" }); // Failed to save. !== 저장이 실패하였습니다. ==!

                let errorMessage = error.message;
                if (error.response?.data?.errorMessage) {
                    errorMessage = error.response.data.errorMessage;
                }
                modal.openModal({ content: errorMessage });
            },
        }),

        // Update Approval Officer Information
        updateAprvOfcrInfo: useFetch({
            api: (data: any) => APIS.updateAprvOfcrInfo(data),
            enabled: false,
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00069",
                    // onCancel: () => {
                    //     fetch.getAprvHistList.fetch();
                    // },
                    // onConfirm: () => {
                    //     navigate(URLS.osci0108004q);
                    // },
                }); // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
                fetch.getAprvHistList.fetch();
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00045" }), // Failed to save. !== 저장이 실패하였습니다. ==!
        }),

        // Check Customs Officer match Count !== 세관직원 일치 count 조회 ==!
        getCstmOfcrMtchCnt: useFetch({
            api: (data: any) => APIS.getCstmOfcrMtchCnt(data),
            enabled: false,
            onSuccess: (data) => {
                if (data.cstmOfcrMtchCnt.content == 0) {
                    modal.openModal({ content: t("msg.osc.00145", { 0: t("L_CSTM_OFCR_CD") }) }); // {0: Customs Officer Code} does not exist. !== {0: 세관직원코드} 가 존재하지 않습니다. ==!
                    return;
                } else {
                    handler.executeAprvOfcrInfoSubmit();
                }
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to save. !== 조회가 실패하였습니다. ==!
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        //결재승인 버튼 클릭
        onSaveBtnClick: () => {
            if (!comnUtils.isEmpty(form.aprvPrcsInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid. !== 데이터가 유효하지않습니다. ==!
                return;
            }
            // save Information of !== 승인 처리 저장 ==!
            form.aprvPrcsInfo.handleSubmit(
                () => {
                    form.aprvPrcsInfo.setValue("aprvId", aprvId);
                    form.aprvPrcsInfo.setValue("aprvPrcssOrd", form.aprvRqstInfo.getValue("lgnUsrAprvPrcssOrd"));
                    form.aprvPrcsInfo.setValue("bsopClsfCd", form.aprvRqstInfo.getValue("bsopClsfCd"));
                    form.aprvPrcsInfo.setValue("rjctStatUseYn", form.aprvRqstInfo.getValue("rjctStatUseYn"));
                    form.aprvPrcsInfo.setValue("sameAprvUsrCnt", form.aprvRqstInfo.getValue("sameAprvUsrCnt"));

                    const data = form.aprvPrcsInfo.getValues();
                    modal.openModal({
                        content: "msg.osc.00090", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.saveAprvPrcsInfo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid. !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
        // 결재 요청 취소 버튼 클릭시
        onCancelBtnClick: () => {
            if (!comnUtils.isEmpty(form.aprvRqstInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid. !== 데이터가 유효하지않습니다. ==!
                return;
            }
            // save Approval Request Processing Information  !== 결재 요청 처리 저장 ==!
            form.aprvRqstInfo.handleSubmit(
                () => {
                    form.aprvRqstInfo.setValue("aprvId", aprvId);
                    const data = form.aprvRqstInfo.getValues();
                    modal.openModal({
                        content: "msg.osc.00090", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.saveAprvCnclInfo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid. !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
        // Click List Button !== 목록 버튼 클릭 ==!
        onListBtnClick: () => {
            navigate(`${URLS.osci0108004q}?menuId=${menuId}`);
        },
        // Approval Processing Tab Settings !== 결재 처리 탭 설정 ==!
        oninitInfo: () => {
            form.aprvHistInfo.setValue("aprvId", aprvId);
        },
        onTabClick: (index: any) => {
            if (index === 0) {
                //결재 문서 선택시
            }
            if (index === 1) {
                //결재 이력 선택시
                handler.oninitInfo();
                fetch.getAprvHistList.fetch();
            }
            if (index === 2) {
                // 결재 처리 선택시
            }
        },
        // Click Approval History List Grid !== 결재이력 목록 그리드 클릭 ==!
        onGridClick: (data: any) => {
            if (!comnUtils.isEmpty(form.aprvHistInfo.getValue("aprvPrcssMetdCd"))) {
                if (aprvChgAuthYn == "Y" && ["W", "P"].includes(flag || "")) {
                    if (handler.checkAprvOfcrChange()) {
                        modal.openModal({
                            content: "msg.osc.00117", // All entered information will be reset. Do you want to change it? !== 입력하신 정보가 모두 초기화됩니다. 변경하시겠습니까? ==!
                            onConfirm: () => {
                                handler.onAprvOfcrUpdateBtnClick();
                            },
                            onCancel: () => {
                                form.aprvHistInfo.setValue("usrDmnId", data.rowValues.usrDmnId);
                                form.aprvHistInfo.setValue("aprvId", data.rowValues.aprvId);
                                form.aprvHistInfo.setValue("aprvPrcssSeq", data.rowValues.aprvPrcssSeq);
                                fetch.getAprvHistInfo.fetch();
                            },
                        });
                        return;
                    }
                }
            }
            form.aprvHistInfo.setValue("usrDmnId", data.rowValues.usrDmnId);
            form.aprvHistInfo.setValue("aprvId", data.rowValues.aprvId);
            form.aprvHistInfo.setValue("aprvPrcssSeq", data.rowValues.aprvPrcssSeq);
            fetch.getAprvHistInfo.fetch();
        },
        setSrc: (data: any) => {
            return data;
        },
        // Click Apprvoal Re-Request Button !== 결재 재요청 버튼 클릭 ==!
        onAprvReRqstBtnClick: () => {
            modal.openModal({
                url: "/ptli/comnmdle/aprv/ptli0409006s", // url 로 팝업창의 주소를 기입
                params: {
                    aprvId: `${form.aprvRqstInfo.getValue("aprvId")}`,
                    scrnDocCd: `${form.aprvRqstInfo.getValue("scrnDocCd")}`,
                }, // 팝업창에 보낼 파라메터 정의
                size: "md",
                draggable: true,
                callback: (data) => {
                    if (data.pgeUid === "ptli0409006s") {
                        modal.closeModal();
                    }
                    navigate(URLS.osci0108004q);
                },
            });
        },

        // Click Approval Officer Save Button !== 결재자 저장 버튼 클릭 ==!
        onAprvOfcrUpdateBtnClick: () => {
            if (!comnUtils.isEmpty(form.aprvHistInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid. !== 데이터가 유효하지않습니다. ==!
                return;
            }
            if (comnUtils.isEmpty(form.aprvHistInfo)) {
                modal.openModal({ content: "msg.osc.00009" }); // No data has been selected. !== 선택된 데이터가 없습니다. ==!
                return;
            }

            if (aprvChgAuthYn == "Y" && ["W", "P"].includes(flag || "")) {
                if (!handler.checkAprvOfcrChange()) {
                    modal.openModal({ content: "msg.osc.00149" }); // No information modified.. !== 변경된 정보가 없습니다. ==!
                    return;
                } else {
                    if (comnUtils.isEmpty(form.aprvHistInfo.getValue("aprvPrcssMetdCd"))) {
                        modal.openModal({ content: "msg.osc.00110" }); // Please select a row. !== 열을 선택하시기 바랍니다. ==!
                        return;
                    } else if (comnUtils.isEmpty(form.aprvHistInfo.getValue("orgUsrId"))) {
                        modal.openModal({ content: t("msg.osc.00051", { 0: t("L_APRV_USR") }) }); // Please enter {0: Approver}. !== {0: 결재자} 을(를) 입력하여 주세요. ==!
                        return;
                    } else {
                        const isCstmOfcrDupl = grid.aprvHistList.getData().some((item: any) => {
                            return item.usrDmnId === form.aprvHistInfo.getValue("orgUsrId");
                        });
                        if (isCstmOfcrDupl) {
                            modal.openModal({ content: t("msg.osc.00150", { 0: t("L_APRV_USR") }) }); // Duplicate data exists. ( {0: Approver} ) !== 중복된 데이터가 존재합니다. ( {0: 결재자} ) ==!
                            return;
                        }

                        modal.openModal({
                            content: "msg.osc.00090", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                            onConfirm: () => {
                                // KNH 존재하는 사용자 인지 체크하는 로직인데 기관 사용자 팝업에서 선택한 사용자 이므로 바로 변경 로직을 호출하도록 변경
                                // fetch.getCstmOfcrMtchCnt.fetch(form.aprvHistInfo.getValues());
                                handler.executeAprvOfcrInfoSubmit();
                            },
                        });
                        return;
                    }
                }
            }
            handler.executeAprvOfcrInfoSubmit();
        },

        // Approval Officer Edit True or False !== 결재자 변경 여부 확인 ==!
        checkAprvOfcrChange: () => {
            // return form.aprvHistInfo.getValue("usrDmnId") == form.aprvHistInfo.getValue("cstmOfcrCd") ? false : true;
            return form.aprvHistInfo.getValue("usrDmnId") == form.aprvHistInfo.getValue("orgUsrId") ? false : true;
        },

        // Update Approval Officer !== 결재자 저장 ==!
        executeAprvOfcrInfoSubmit: () => {
            form.aprvHistInfo.handleSubmit(
                () => {
                    // form.aprvHistInfo.setValue("usrDmnId", form.aprvHistInfo.getValue("cstmOfcrCd"));
                    form.aprvHistInfo.setValue("usrDmnId", form.aprvHistInfo.getValue("orgUsrId"));
                    form.aprvHistInfo.setValue("prcssLastMdfrId", auth.get("usrId"));
                    fetch.updateAprvOfcrInfo.fetch(form.aprvHistInfo.getValues());
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid. !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        const authList = auth.get("authList");
        if (!comnUtils.isEmpty(authList)) {
            const isAprvChgAuth = authList.some((auth: any) => {
                // Authorization to change approver !== 전자결재 결재자 변경 권한 ==!
                return auth == "auth_osci0004";
            });
            if (isAprvChgAuth) {
                setAprvChgAuthYn("Y");
            }
        }

        //결재 처리 탭 숨김 여부
        tab.setVisible(2, flag === "W" && usrDmnId == auth.get("usrId") ? true : false);

        //결재이력 목록 시
        form.aprvRqstInfo.setEditable(false);
        form.aprvDocInfo.setEditable(false);
        form.aprvHistInfo.setEditable(false);
        // form.aprvHistInfo.setEditable("cstmOfcrCd", true);
        form.aprvHistInfo.setEditable("orgUsrNm", true);

        handler.onTabClick(0);
    }, []);

    return (
        <Page info={true}>
            <Group>
                <Group.Body>
                    <Group>
                        <Group.Body>
                            <Group.Title title={t("L_APRV_RQST_CN")} titleSize={2} />
                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...form.aprvRqstInfo.schema.aprvRqstTtleNm}></Group.Control>
                                    <Group.Control {...form.aprvRqstInfo.schema.aprvPrcssStatCdNm}></Group.Control>
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.aprvRqstInfo.schema.usrNm}></Group.Control>
                                    <Group.Control {...form.aprvRqstInfo.schema.aprvRqstDtm}></Group.Control>
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.aprvRqstInfo.schema.aprvRqstCn}></Group.Control>
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.aprvRqstInfo.schema.aprvPrcssOpinCn}></Group.Control>
                                </Group.Row>
                            </Group.Section>
                        </Group.Body>
                    </Group>
                    <Tab
                        {...tab.tab}
                        onChange={(index) => {
                            handler.onTabClick(index);
                        }}
                    >
                        <Tab.Panel>
                            {!comnUtils.isEmpty(iframeSrc) && <Iframe src={iframeSrc} height={900} />}
                        </Tab.Panel>

                        <Tab.Panel>
                            <Layout>
                                <Group>
                                    <Group.Body>
                                        <Group.Title title={t("T_APRV_HIST_LST")} titleSize={2} />
                                        <Group.Section>
                                            <Grid
                                                {...grid.aprvHistList.grid}
                                                data={fetch.getAprvHistList.data?.aprvHistList}
                                                onCellClick={handler.onGridClick}
                                            />
                                        </Group.Section>
                                    </Group.Body>
                                </Group>
                            </Layout>
                            <Layout>
                                <Group>
                                    <Group.Body>
                                        <Group.Title title={t("T_APRV_PRCSS_INFO")} titleSize={2} />
                                        <Group.Section>
                                            <Group.Row>
                                                {/* TODO 사용자 ID를 선택할 수 있게 해야 함 */}
                                                {/* <Group.Control {...form.aprvHistInfo.schema.cstmOfcrCd}></Group.Control> */}
                                                {aprvChgAuthYn == "Y" && ["W", "P"].includes(flag || "") && (
                                                    <Group.Control
                                                        {...form.aprvHistInfo.schema.orgUsrNm}
                                                        rightButton={{
                                                            icon: "search",
                                                            onClick: () => {
                                                                modal.openModal({
                                                                    content: (
                                                                        <OSCI0108006Q
                                                                            aprvId={aprvId}
                                                                            callbackFn={(rtnData: any) => {
                                                                                form.aprvHistInfo.setValues({
                                                                                    orgUsrId: rtnData.usrIdntfNo,
                                                                                    orgUsrNm: rtnData.usrNm,
                                                                                });
                                                                                modal.closeModal("PTLO0409006Q");
                                                                            }}
                                                                        />
                                                                    ),
                                                                    size: "sm",
                                                                    id: "PTLO0409006Q",
                                                                });
                                                            },
                                                        }}
                                                    ></Group.Control>
                                                )}
                                                {!(aprvChgAuthYn == "Y" && ["W", "P"].includes(flag || "")) && (
                                                    <Group.Control {...form.aprvHistInfo.schema.usrNm}></Group.Control>
                                                )}
                                                <Group.Control
                                                    {...form.aprvHistInfo.schema.lastAprvYnNm}
                                                ></Group.Control>
                                            </Group.Row>
                                            <Group.Row>
                                                <Group.Control
                                                    {...form.aprvHistInfo.schema.aprvPrcssDtm}
                                                ></Group.Control>
                                            </Group.Row>
                                            <Group.Row>
                                                <Group.Control
                                                    {...form.aprvHistInfo.schema.aprvPrcssOpinCn}
                                                ></Group.Control>
                                            </Group.Row>
                                        </Group.Section>
                                        <Group.Section>
                                            <Layout.Right>
                                                {aprvChgAuthYn == "Y" && ["W", "P"].includes(flag || "") && (
                                                    <Layout.Button
                                                        role={"save"}
                                                        onClick={() => {
                                                            handler.onAprvOfcrUpdateBtnClick();
                                                        }}
                                                    />
                                                )}
                                                {/* {form.aprvRqstInfo.getValue("aprvPrcssStatCd") === "A01" &&
                                                    auth.get("usrId") === form.aprvRqstInfo.getValue("usrDmnId") && (
                                                        <Layout.Button variant="primary" disabled={true}>
                                                            {t("B_APRV_RQST")}
                                                        </Layout.Button>
                                                    )} */}
                                                {form.aprvRqstInfo.getValue("aprvPrcssStatCd") === "A01" &&
                                                    auth.get("usrId") === form.aprvRqstInfo.getValue("usrDmnId") &&
                                                    form.aprvRqstInfo.getValue("grpAprvYn") !== "Y" && (
                                                        <Layout.Button
                                                            variant="contained"
                                                            onClick={handler.onCancelBtnClick}
                                                        >
                                                            {t("B_APRV_RQST_CNCL")}
                                                        </Layout.Button>
                                                    )}
                                                {form.aprvRqstInfo.getValue("aprvPrcssStatCd") === "B03" &&
                                                    form.aprvRqstInfo.getValue("grpAprvYn") !== "Y" && (
                                                        <Layout.Button
                                                            variant="contained"
                                                            onClick={handler.onCancelBtnClick}
                                                            disabled={true}
                                                        >
                                                            {t("B_APRV_RQST_CNCL")}
                                                        </Layout.Button>
                                                    )}
                                            </Layout.Right>
                                        </Group.Section>
                                    </Group.Body>
                                </Group>
                            </Layout>
                        </Tab.Panel>
                        <Tab.Panel>
                            <Layout direction={"row"}>
                                <Layout>
                                    <Group>
                                        <Group.Body>
                                            <Group.Section>
                                                <Group.Row>
                                                    <Group.Control
                                                        {...form.aprvPrcsInfo.schema.lastAprvYn}
                                                    ></Group.Control>
                                                    <Group.Control {...form.aprvRqstInfo.schema.docNm}></Group.Control>
                                                </Group.Row>
                                                <Group.Row>
                                                    <Group.Control
                                                        {...form.aprvPrcsInfo.schema.aprvPrcssOpinCn}
                                                    ></Group.Control>
                                                </Group.Row>
                                            </Group.Section>
                                            <Layout.Right>
                                                {usrDmnId == auth.get("usrId") && (
                                                    <Layout.Button role={"save"} onClick={handler.onSaveBtnClick} />
                                                )}
                                            </Layout.Right>
                                        </Group.Body>
                                    </Group>
                                </Layout>
                            </Layout>
                        </Tab.Panel>
                    </Tab>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
            </Layout>
        </Page>
    );
};
